import { Icon_CodeXml } from '@urbanx/agx.ui-components2'

interface Props {
  height?: string
  width?: string
  color?: string
  padding?: string
  opacity?: number
}

const DevIcon = (props: Props) => {
  const {
    height = '20',
    width = '20',
    color = '#FFFFFF',
    padding = 'var(--padding-xs)',
    opacity = 1,
  } = props

  return (
    <div style={{ padding, opacity }}>
      <Icon_CodeXml
        height={Number(height)}
        width={Number(width)}
        color={color}
      />
    </div>
  )
}

export default DevIcon
